export const SORT_FIELD_MAP = {
    orderNumber: 'num',
    deliverTo: 'delivered_date',
    amount: 'total_final_price',
}

export const API_TO_SORT_FIELD_MAP = Object.fromEntries(
    Object.entries(SORT_FIELD_MAP).map(([k, v]) => [v, k])
)
